import React, { useState, useEffect } from 'react';
import ApiService from '../../services/apiService';
import { setRows } from '../../../Redux/actions/rowActions';
import { useCurrency } from '../../Layouts/currencyContext';
import { useDispatch, useSelector } from 'react-redux';
const ItemGridView = ({ itemData, currencyPrecision }) => {
  const apiService = new ApiService();
  const dispatch = useDispatch();

  const rows = useSelector((state) => state.rows.rows);
  const netAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.amount) || 0), 0);
  const totalVat = rows.reduce((sum, row) => sum + (parseFloat(row?.vatAmount) || 0), 0);
  const totalDiscountAmount = rows.reduce((sum, row) => sum + (parseFloat(row?.discountAmount) || 0), 0);
  const totalDiscount = rows.reduce((sum, row) => sum + (parseFloat(row?.discount) || 0), 0);
  const calculatedTotal = rows.reduce((sum, row) => sum + (parseFloat(row?.amount - row?.vatAmount) || 0), 0);
  useEffect(() => {
    const getItems = async () => {
      const formattedRowsPromises = itemData?.poDetails
        ?.map(async (detail, index) => {
          const getunit = await apiService.getApiParamater('GET_ITEM_PACK', `?ItemNo=${detail.itemCode}`);
          // const selectedItem = res.data.result?.find(item => item.itemNo === detail.itemCode);

          let selectedItem = getunit?.data?.result[0];
          return {
            srno: detail?.srno,
            itemCode: detail.itemCode,
            recordId: detail.itemCode,
            itemDescription: detail.itemDescription,
            qty: detail.qty || 0,
            uom: detail.uom,
            stock: detail.qty * selectedItem.convToInvUOM,
            baseQty: selectedItem.convToInvUOM,
            unitPrice: detail.unitPrice,
            specification: detail.specification,
            discount: detail.discount,
            discountAmount: detail?.discountamount,
            amount: detail?.amount,
            vat: detail?.vatPerc || 0,
            vatAmount: detail?.vatAmount || 0,
            calculatedAmount: detail?.amount,
          };
        })
        .filter((row) => row !== null);
      const formattedRows = await Promise.all(formattedRowsPromises);
      if (formattedRows?.length > 0) {
        setRows(formattedRows.reverse());
        dispatch(setRows(formattedRows));
      }
    };
    if (itemData) {
      getItems();
    }
  }, [itemData]);

  return (
    <div>
      <div className="table-container p-2 mb-5" style={{ overflowX: 'auto', height: '400px' }}>
        <table>
          <thead className="dynoTable">
            <tr>
              <th>Sr no</th>
              <th>Item No</th>
              <th>Description</th>
              <th>Item Specs</th>
              <th>Qty</th>
              <th>Packing UOM</th>
              <th>Inventory Qty</th>
              <th>Unit Price</th>
              <th>Discount</th>
              <th>VAT %</th>
              <th>VAT Amount</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            {rows?.map((row, index) => (
              <tr key={index}>
                <td className="m-0 p-0">
                  <input className="p-2" type="text" value={index + 1} disabled style={{ width: '120px' }} />
                </td>
                <td className="m-0 p-0 itemCol">
                  <input className="p-2 w-100" disabled value={row.itemCode} />
                </td>
                <td className="m-0 p-0 descriptionCol">
                  <input className="p-2 w-100" disabled value={row.itemDescription} />
                </td>
                <td className="m-0 p-0">
                  <input className="p-2" disabled value={row.specification} style={{ width: '350px' }} />
                </td>
                <td className="m-0 p-0">
                  <input className="p-2" disabled value={row.qty} style={{ width: '120px' }} />
                </td>
                <td className="m-0 p-0">
                  <input className="p-2" disabled value={row.uom} style={{ width: '140px' }} />
                </td>
                <td className="m-0 p-0">
                  <input className="p-2" disabled value={row.stock || 0} style={{ width: '140px' }} />
                </td>
                <td className="m-0 p-0">
                  <input className="p-2" disabled value={row.unitPrice} style={{ width: '120px' }} />
                </td>
                <td className="m-0 p-0">
                  <input className="p-2" disabled value={row.discount} style={{ width: '120px' }} />
                </td>
                <td className="m-0 p-0">
                  <input className="p-2" type="text" style={{ width: '120px' }} value={(row?.vat === undefined ? 0 : row?.vat + '%') || 0} disabled />
                </td>
                <td className="m-0 p-0">
                  <input className="p-2" type="text" value={Number(row?.vatAmount || 0).toFixed(currencyPrecision || 0)} disabled style={{ width: '120px' }} />
                </td>
                <td className="m-0 p-0">
                  <input
                    className="p-2"
                    disabled
                    value={row.amount === NaN ? 0 : Number(row.amount || 0).toFixed(currencyPrecision || 0) || 0}
                    style={{ width: '120px' }}
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <div className="d-flex justify-content-between boxs">
        <div className="d-flex gap-2">
          <div className="totalhead center">Discount</div>
          <div className="field">{`${totalDiscount.toFixed(currencyPrecision || 0)} ${'%'}` || '---'}</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Amount</div>
          <div className="field">{calculatedTotal.toFixed(currencyPrecision || 0) || '---'}</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Discount</div>
          <div className="field">{totalDiscountAmount.toFixed(currencyPrecision || 0) || '---'}</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Total Vat</div>
          <div className="field">{totalVat.toFixed(currencyPrecision || 0) || '---'}</div>
        </div>
        <div className="d-flex gap-2">
          <div className="totalhead center">Net Amount</div>
          <div className="field">{netAmount.toFixed(currencyPrecision || 0) || '---'}</div>
        </div>
      </div>
    </div>
  );
};

export default ItemGridView;
